import { AxiosResponse, AxiosError } from 'axios';
import { Code, ResponseData } from '../types';
import { showFailToast } from 'vant';
import { useUserStore } from '@/store/modules/user';
import { router } from '@/router';
import { ErrorCode } from '../types';
interface HttpResponse {
  status: number;
  data: any;
  [key: string]: any;
}

const needHandle = [ErrorCode.NEED_HANDLE_TIP_33001, ErrorCode.NEED_HANDLE_TIP_33000];
export function responseSuccess(response: AxiosResponse<ResponseData>) {
  if (response) {
    const { data, headers, request } = response;
    const userStore = useUserStore();

    if (headers['should-refresh-token'] && headers['should-refresh-token'] === '1') {
      // refresh token
      userStore.updateToken();
    }

    const { errorCode: code, message } = data;
    if (code !== ErrorCode.SUCCESS) {
      if (code === ErrorCode.NEED_LOGOUT) {
        if (window.location.pathname.includes('/train-schedule')) {
          return showFailToast('链接已失效！');
        } else {
          const userStore = useUserStore();
          userStore.logout();
        }
      }
      if (code === ErrorCode.HANDLE_EMPTY_RECORD) {
        showFailToast(message);
        router.push('/changeRecord');
      }
      if (code === ErrorCode.SELECT_SCHEDULE_DETAIL) {
        return data;
      }
      if (!needHandle.includes(code)) {
        showFailToast(message);
      }
    }
    return data;
  } else {
    return Promise.reject();
  }
}
export function responseError(error: AxiosError) {
  const userStore = useUserStore();
  const { response, code, message: msg } = error || {};
  const httpResponse = response as HttpResponse;
  console.log(
    httpResponse,
    code,
    msg,
    error,
    '-----httpResponse-----',
    msg && msg.includes('Network Error'),
  );
  const err: string = error.toString();
  try {
    // @ts-ignore

    if (code === 'ECONNABORTED' && msg?.toLowerCase().includes('timeout')) {
      userStore.setShowSystemErrorFlag(true);
      userStore.setSystemErrorText('请求超时，请刷新页面后重试');
      return;
    }

    if (msg && msg?.toLowerCase().includes('network error')) {
      userStore.setShowSystemErrorFlag(true);
      userStore.setSystemErrorText('网络异常');
      return;
    }
    if (code === 'ERR_BAD_RESPONSE') {
      userStore.setShowSystemErrorFlag(true);
      userStore.setSystemErrorText('服务器错误，请稍后重试');
      return;
    }
    if (code === 'ERR_BAD_REQUEST') {
      userStore.setShowSystemErrorFlag(true);
      userStore.setSystemErrorText('非法请求，请稍后重试');
      return;
    }
    if (
      !httpResponse ||
      /^5\d*$/.test(httpResponse?.data?.status) ||
      /^5\d*$/.test(String(httpResponse?.status))
    ) {
      userStore.setShowSystemErrorFlag(true);
      userStore.setSystemErrorText(msg);
      return;
    }
  } catch (error) {
    throw new Error(error as any);
  }
}
